import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import _toInteger from 'lodash/toInteger';
import { DispatchEventReportDataProvider } from '../../core/context/DispatchEventReportDataContext';
import { DispatchEventFieldOptionsProvider } from '../../core/context/DispatchEventFieldOptionsContext';
import { AuthorizationRequestType } from '../../core/api/clients';

function DispatchEventFormLayout() {
  const { formId } = useParams<'formId'>();
  const { action } = useParams<'action'>();

  let requestType = AuthorizationRequestType.Contribute;
  if (action === 'approve') {
    requestType = AuthorizationRequestType.Approve;
  } else if (action === 'read') {
    requestType = AuthorizationRequestType.Read;
  } else if (action === 'view') {
    requestType = AuthorizationRequestType.View;
  }

  return (
    <div>
      <DispatchEventReportDataProvider dispatchEventReportId={_toInteger(formId)} role={requestType}>
        <DispatchEventFieldOptionsProvider>
          <Outlet />
        </DispatchEventFieldOptionsProvider>
      </DispatchEventReportDataProvider>
    </div>
  );
}

export default DispatchEventFormLayout;
